import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl,FormBuilder} from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../../../services/app-config-service.service';
import { AppSourcesService } from '../../../services/app-sources-service.service';
import { RecaptchaComponent} from 'ng-recaptcha';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-search-form',
  templateUrl: './search-form.component.html',
  styleUrls: ['./search-form.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class SearchFormComponent implements OnInit {

  constructor(private sources:AppSourcesService ,private http: HttpClient, private fb:FormBuilder) { }

  @ViewChild('formElem') formElem:any;
  @ViewChild('captchaRef') captchaRef: RecaptchaComponent;
  @ViewChild(MatSort) sort: MatSort;

  siteKey:string ='';
  serverUrl:string ='';
  loading:boolean = false;
  showPrint:boolean = false;
  showExtra:boolean = false;
  extraLinkText:string='';
  displayedColumns:string[]=[];
  displayedColumnsNoPrint: string[] = [ 'Name','RegistrationNumber','RegistrationDate'];
  displayedColumnsPrint: string[] = [ 'Name','RegistrationNumber','RegistrationDate', 'Print'];
  dataSource: MatTableDataSource<any>=new MatTableDataSource<any>([]);
  expandedElement:any | null;

  sw:any = {
    ResultCode:null,
    ResultMsg:null,
    SocialWorkers:[]
  };

  form:FormGroup;

  ngOnInit(): void {
    this.siteKey = this.sources.appSettings.siteKey;
    this.extraLinkText = this.sources.extra;
    this.form = this.fb.group({
      TzNumber: new FormControl('',Validators.compose([oneParameter(),tz()])),
      RegistrationNumber: new FormControl(''),
      FirstName: new FormControl('',Validators.compose([fullName()])),
      LastName: new FormControl('',Validators.compose([fullName()])),
      RecaptchaResponse: new FormControl('')
    },{updateOn:'submit'});
  }

  ngAfterViewInit():void{
    this.captchaRef.execute();
  }

  clean():boolean{
    this.form.controls['TzNumber'].reset();
    this.form.controls['RegistrationNumber'].reset();
    this.form.controls['FirstName'].reset()
    this.form.controls['LastName'].reset();
    this.sw={};
    return false;
  }

  isFirstCalling:boolean = true;
  callingRecaptchaCount:number = 0;
  onSubmit(): void {
    this.sw={};
    this.form.controls['TzNumber'].updateValueAndValidity();
    this.form.controls['FirstName'].updateValueAndValidity();
    this.form.controls['LastName'].updateValueAndValidity();
    if(!this.form.valid){
      this.formElem.nativeElement.classList.add('form-invalid');
      return;
    }
    this.loading = true;
    if(!this.form.controls['RecaptchaResponse'].value){
      setTimeout(() => {
          this.callingRecaptchaCount++;
          if(this.callingRecaptchaCount<3)
            this.onSubmit();
          else{
            this.sw = {
              ResultCode:-4,
              ResultMsg:'חלה תקלה, יש לנסות מאוחר יותר.',
              SocialWorkers:[]
            };
            this.loading = false;
          }
      },100);
      return;
    }
    this.showPrint = this.form.value.TzNumber?true:false;
    this.displayedColumns = this.showPrint? this.displayedColumnsPrint:this.displayedColumnsNoPrint;
    this.formElem.nativeElement.classList.remove('form-invalid');
    const parameters = JSON.parse(JSON.stringify(this.form.value));
    if(parameters.TzNumber)
      parameters.TzNumber = Number(parameters.TzNumber);
    else
      //delete parameters.TzNumber;
      parameters.TzNumber=-1;
    if(parameters.RegistrationNumber)
      parameters.RegistrationNumber = Number(parameters.RegistrationNumber);
    else
      //delete parameters.RegistrationNumber;
      parameters.RegistrationNumber=-1;
    const sData = JSON.stringify(parameters);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json','Strict-Transport-Security':'max-age=31536000; includeSubDomains'},
        body: sData,
        withCredentials:true
    };
    fetch(this.sources.appSettings.serverUrl+'/api/search', requestOptions)
        .then(response => response.json())
        .then(res =>{
          if(res.ResultCode==-5 && this.isFirstCalling==true){
            this.isFirstCalling = false;
          }
          else{
            this.isFirstCalling = true;
            this.sw = res;
            if(this.sw.ResultCode<0 && !this.sw.ResultMsg)
              this.sw.ResultMsg = 'חלה תקלה, יש לנסות מאוחר יותר';
            this.dataSource = new MatTableDataSource<any>(this.sw.SocialWorkers);
            setTimeout(() => {
                //this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            });
            this.loading = false;
          }
          this.captchaRef.reset();
          this.captchaRef.execute();
        })
        .catch(error => {
          this.sw = {
            ResultCode:-7,
            ResultMsg:'חלה תקלה, יש לנסות מאוחר יותר',
            SocialWorkers:[]
          };
          console.error('There was an error!', error);
          this.loading = false;
        });
  }

  recaptchaResolve(captchaResponse:string) {
    if (captchaResponse) {
      this.form.controls.RecaptchaResponse.setValue(captchaResponse);
      if(!this.isFirstCalling){
        this.onSubmit();
      }
    }
  }

  getRegistrationDate(w:any):string{
    const d:Date =new Date(w.RegistrationDate); 
    //return d.toLocaleDateString();
    return (d.getDate()<10?("0"+d.getDate()):d.getDate()).toString()+"."+((d.getMonth()+1)<10?("0"+(d.getMonth()+1)):(d.getMonth()+1)).toString()+"."+d.getFullYear().toString();
  }

  toJsonString(obj:any):string{
   return JSON.stringify(obj); 
  }

  getErrors(ctrl):string{
    let msg:string = '';
    for(var key in this.form.controls[ctrl].errors){
      switch(key){
        case 'required':msg += 'שדה חובה';break;
        default:msg += this.form.controls[ctrl].errors[key];
      }
    }
    return msg;
  }

  maxlength(event:any,max:number):void{
    if(event.target.value.length>max)
      event.target.value=event.target.value.slice(0,max);
  }

  showLinkExtra():void{
    this.showExtra = ! this.showExtra;
  }

  html:string='';

  printClick(w:any):void{
    try{
      this.html = this.sources.print;
      var fullDate = new Date()
      var currentDate = (fullDate.getDate()<10 ? '0':'')+fullDate.getDate().toString() + "." + (fullDate.getMonth()<9 ? '0':'')+(fullDate.getMonth()+1).toString() + "." + fullDate.getFullYear();
      this.html = this.html.replace('@@currentDate@@',currentDate);
      this.html = this.html.replace('@@Name@@',w.Name);
      this.html = this.html.replace('@@RegNum@@',w.RegistrationNumber);
      this.html = this.html.replace('@@RegDate@@',this.getRegistrationDate(w));
      this.html = this.html.replace('@@RegNote@@',w.SocialWorkerNote);
      var disp_setting = "toolbar=yes,location=no,directories=yes,menubar=yes,scrollbars=yes,width=850, height=600, left=100, top=25";
      var docprint = window.open("", "", disp_setting);
      docprint.opener=null;
      docprint.document.open();
      docprint.document.write(this.html);
      if (navigator.appName != "Microsoft Internet Explorer") {
          docprint.document.close();
      }
      else {
          docprint.location.reload(false);
      }
      docprint.focus();
    }
    catch (err) {
      console.log(err);
      alert('חלה תקלה בהדפסת האישור, נא נסה מאוחר יותר');
    }
  }
}

export function fullName():ValidatorFn{
  return (control:AbstractControl):{[key:string]:any}| null=>{
    if(!control.parent || control.value)
      return null;
    const fn = control.parent.controls['FirstName'].value;
    const ln = control.parent.controls['LastName'].value;
    return !fn && !ln ? null : {fullName:'בחיפוש לפי שם יש להזין גם את השם הפרטי וגם את שם המשפחה'};
  }
}

export function oneParameter():ValidatorFn{
  return (control:AbstractControl):{[key:string]:any}| null=>{
    if(control.value || !control.parent || control.parent.controls['RegistrationNumber'].value || control.parent.controls['FirstName'].value 
      || control.parent.controls['LastName'].value)
      return null;
    return {oneParameter:'חובה להזין מספר זהות / מספר רישום בפנקס / שם פרטי ושם משפחה'};
  }
}

export function tz():ValidatorFn{
  return (control:AbstractControl):{[key:string]:any}| null=>{
    if(!control.value)
      return null;
    let sum:number=0;
    const arrTz = control.value.toString().split('').reverse().map(x=>Number(x));
    for(var i=1;i<arrTz.length;i++){
      if(i%2==0)
        sum += arrTz[i];
      else{
        let a = arrTz[i]*2;
        if(a>9)
          a = Math.floor(a/10)+a%10;
        sum += a;
      } 
    }
    const mod:number = sum%10; 
    if(10 - (mod > 0 ? mod : 10) == arrTz[0])
      return null;
    return {tz:"יש להזין מספר זהות תקין כולל ספרת ביקורת"};
  }
}
